import { Button } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

type Props = {
  loadMore: () => void;
  isLoadingMore: boolean;
};

const LoadMore: React.FC<Props> = (props) => {
  const { loadMore, isLoadingMore } = props;
  const { locale = "it" } = useRouter();

  const t = {
    loadMore: useTranslation("productListing.loadMore", locale) || "",
  };

  return (
    <Button disabled={isLoadingMore} onClick={() => loadMore()}>
      {t.loadMore}
    </Button>
  );
};

export default LoadMore;
